/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { MerchantService, NotificationService } from "../../../services";
import { Error, Merchant } from "../../../models";
import { MERCHANT_CONSTANTS } from "../../../utils/data.rest.constants";
import { throwError } from "rxjs";

@Component({
  selector: "app-payment-processor-info",
  templateUrl: "./payment-processor-info.component.html"
})
export class PaymentProcessorInfoComponent {
  worldpayUnderwritingStatusInProgress = false;
  @Input("loaded") loaded = false;
  @Input("merchant") merchant!: Merchant;

  constructor(public merchantService: MerchantService, public notificationService: NotificationService) {}

  isWorldPay(): boolean {
    return this.merchantService.isWorldPay(this.merchant);
  }

  isMerchantActive(): boolean {
    return this.merchant.status === "ACTIVE";
  }

  checkWorldpayUnderwritingStatus(): void {
    if (!this.worldpayUnderwritingStatusInProgress) {
      this.worldpayUnderwritingStatusInProgress = true;
      this.merchantService.worldPayHealthCheck().subscribe(
        (response) => {
          if (response.status === MERCHANT_CONSTANTS.UP) {
            this.merchantService.getWorldPayUnderwritingStatus(this.merchant.id).subscribe(
              (underWritingStatus) => {
                this.merchant.accountDetails.worldPayAccountDetails.worldpayUnderwritingStatus =
                  underWritingStatus.status;
                this.worldpayUnderwritingStatusInProgress = false;
              },
              (error: Error) => {
                this.worldpayUnderwritingStatusInProgress = false;
                this.notificationService.error(error.error);
              }
            );
          } else throwError({ response: "502", data: { message: "Worldpay api is currently down" } });
        },
        (error: any) => {
          this.worldpayUnderwritingStatusInProgress = false;
          this.notificationService.error(error.error);
        }
      );
    }
  }
}
